export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "society",
      layout: "dashboard",
    },
    path: "/deposits",
    name: "deposits",
    component: () => import("@/layouts/index/DepositIndex.vue"),
    children: [
      
     
      
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Dépôts",
          layout: "dashboard",
        },
        path: "deposits/index",
        name: "deposits-index",
        component: () => import("@/views/deposits/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un dépôts",
          layout: "dashboard",
        },
        path: "deposits/create",
        name: "deposits-create",
        component: () => import("@/views/deposits/Create.vue"),
      },
    ],
  },
];
